import { Root as SwitchPrimitiveRoot, Thumb as SwitchPrimitiveThumb } from "@radix-ui/react-switch";
import { styled } from "@vitality-ds/system";
import baseSwitchStyles from "./styles/BaseSwitch.styles";
import baseSwitchLabelStyles from "./styles/BaseSwitchLabel.styles";
import baseSwitchThumbStyles from "./styles/BaseSwitchThumb.styles";
export var BaseSwitchThumb = styled(SwitchPrimitiveThumb, baseSwitchThumbStyles);
export var BaseSwitch = styled(SwitchPrimitiveRoot, baseSwitchStyles);
export var BaseSwitchLabel = styled("label", baseSwitchLabelStyles);